export default "__VITE_ASSET__BXTjkN4H__"